import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    standalone: false
})
export class SignupComponent {
     constructor(public generalService: GeneralService, 
          private enrollmentService: EnrollmentService,
          private _router:  Router) {
          
     }

     ngOnInit(): void {
          if(environment.NODE_ENV !== ''){
               
               const currentRoute = this.generalService.setRoute;
               if (currentRoute !== '/signup/welcome') {
                    this._router.navigateByUrl('/');
               }
          }
     }

}
